const FeetViewportToSeats = {
  order: Infinity,
  run($$) {
    $$.feetViewportToSeats = function () {
      const initialMin = {
        x: Infinity,
        y: Infinity,
      };
      const min = Object.values($$.seats).reduce(function (acc, {
        row,
        seat,
        x,
        y,
      }) {
        acc.x = Math.min(acc.x, x);
        acc.y = Math.min(acc.y, y);
        return acc;
      }, initialMin);

      Object.values($$.seats).forEach(function ({
        row,
        seat,
      }) {
        $$.seats[`${row}-${seat}`].x -= min.x - 1;

        $$.seats[`${row}-${seat}`].y -= min.y - 1;
      });

      return $$.$.trigger("seat:rearrange", [Object.values($$.seats)]);
    };
  },
};

window.SectionFeetViewportToSeats = FeetViewportToSeats;

export default FeetViewportToSeats;
